var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExporticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.427 9.76824C19.1087 9.76824 18.854 10.0229 18.854 10.3412V15.5535C18.854 16.9711 17.6995 18.1214 16.2861 18.1214H3.71392C2.29626 18.1214 1.14601 16.9669 1.14601 15.5535V10.2564C1.14601 9.93802 0.891341 9.68335 0.573005 9.68335C0.254669 9.68335 0 9.93802 0 10.2564V15.5535C0 17.6036 1.66808 19.2674 3.71392 19.2674H16.2861C18.3362 19.2674 20 17.5993 20 15.5535V10.3412C20 10.0272 19.7453 9.76824 19.427 9.76824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59647 14.7177C9.70682 14.8281 9.85538 14.8875 9.99969 14.8875C10.144 14.8875 10.2926 14.8323 10.4029 14.7177L14.0447 11.076C14.2696 10.851 14.2696 10.4902 14.0447 10.2653C13.8197 10.0403 13.4589 10.0403 13.234 10.2653L10.5727 12.9308V1.30518C10.5727 0.986847 10.318 0.732178 9.99969 0.732178C9.68136 0.732178 9.42669 0.986847 9.42669 1.30518V12.9308L6.76115 10.2653C6.5362 10.0403 6.17541 10.0403 5.95046 10.2653C5.7255 10.4902 5.7255 10.851 5.95046 11.076L9.59647 14.7177Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExporticon);
export default __webpack_public_path__ + "static/media/export.icon.e3d8eb1aa75746f3bfd774c2a2772357.svg";
export { ForwardRef as ReactComponent };